import { isNullOrUndefined } from 'util';
import { UserMaster } from './../Model/UserMaster';
import { GRBooking } from './../Model/GRBooking';
import { City } from './../Model/City';
import { GRbookingervice } from './../service/GRbookingservice';
import { Trpconsignmentinv } from './../Model/Trpconsignmentinv';
import { Trpconsignment } from './../Model/Trpconsignment';
import { PartyMaster } from './../Model/PartyMaster';
import { LocationMaster } from './../Model/LocationMaster';
import { MasterConfigrationService } from '../service/MasterConfigrationService';
import { AutoLogoutService } from './../service/auto-logout.service';
import { AlertsService } from 'angular-alert-module';
import { CommonService } from './../service/CommonService';
import { UserService } from '../service/user.service';
import { Component, OnInit, Input } from '@angular/core';
import { PagerService } from '../service/pager-service.service';
import { FormControl, NgForm } from "@angular/forms";
import { Observable } from 'rxjs';
import { map, startWith, isEmpty } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Trpcharges } from '../Model/Trpcharges';
import { Trptvcharges } from '../Model/Trpvtcharges';
import { _MatTabHeaderMixinBase } from '@angular/material/tabs/typings/tab-header';
import { Applicationcl } from '../Model/Applicationcl';
import { PartySuppliers } from '../Model/PartySuppliers';
import { TrpPaidTopaycharge } from '../Model/TrpPaidTopaycharge';
import { ServiceStatus } from '../Model/ServiceStatus';
import { ResponseCode } from '../CheckResponse';
import { LookupService } from '../service/LookupService';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'GRbooking',
  templateUrl: './GRbooking.component.html',
  styleUrls: [ './GRbooking.component.css' ]
})
export class GRbookingComponent implements OnInit {

  public pager: any = {};
  public pagedItems: any[];
  public FromLocations: LocationMaster[] = [];
  public ToLocations: any[];
  public LocationId: number;
  public IsFullLoad: boolean = false;
  public FullLoadVehicle: string;
  public VehicleType: string[];
  public partylist: any[] = [];
  public ConsignerNameAddress: string;
  public PartySuppliers: any[];
  public ConsigneeNameAddress: string;
  public BillingPartyNameAddress: string;
  public PackingType: string[];
  public PackingTypeSelected: string;
  public Banks: any[]
  public LocationBankID: string;
  public LoginFullName: string;
  public PartyAccCode: string;
  public CreatedByFullName: string;
  //It is for autocomplete search box
  public myControl = new FormControl();
  public myControlConsignee = new FormControl();
  public myControlBiller = new FormControl();
  public Consigneroptions: string[] = [];
  public Consigneeoptions: string[] = [];
  public BillerOptions: string[] = [];
  public filteredOptions: Observable<string[]>;
  public filteredOptionConsignee: Observable<string[]>;
  public filteredOptionBiller: Observable<string[]>;
  public DefaultDate: string;
  public InvoiceValidationResult: boolean = true;
  public GRValidationResult: boolean = true;
  public AddPartyValidationResult: boolean = true;
  public IsGRGenerated: boolean = false;
  private userId: number;
  public InvoiceList: any[] = [];
  public TotalInvoiceValue: number = 0;
  public TotalInvoiceGST: number = 0;
  public GreenTax: number = 0;
  public IsUpdate: boolean = false;
  public IsDefaultChargeCalculate: boolean = true;
  public IsSubmit: boolean = true;
  public GRNO: string;
  public BillerList: PartyMaster[];
  public billingParty: string;
  public Citys: City[];
  public AddPartyOption: number = 0;
  public Mrgeneratedauto: boolean = false;
  public IsPackage: boolean = false;
  public IsWeight: boolean = true;
  public IsFull: boolean = false;
  public FrightOnelected = "Weight";
  public RoleId: number = 0;
  public loccode: number = 0;

  public labourBasecharge: number = 0;
  public lGreenTaxlist: any[];
  public MinWeightAndFreightRuleApplied: boolean = false;
  public ISEditableCharges: boolean = true;
  public InvoiceId: number = 1;
  public ISEditInvoice: boolean = false;
  public SelectedInvoiceId: number = 0;
  public bPODCopy: boolean = true;
  public bCRCopy: boolean = true;
  public bCNCopy: boolean = true;
  public IsTDS: boolean = false;
  public RefNoPrefix: string;
  public RefNo: string;
  public IsFreightTypeChange: Boolean = false;
  public EwayDetail: any;
  //end
  //Searche consigner by name
  public ConsignorName: string;
  public SearchFor: string;
  public SearchedItems: any[];

  constructor (private _service: UserService, private oMasterConfigrationService: MasterConfigrationService, public commonservice: CommonService, private alerts: AlertsService, private AutoLogoutService: AutoLogoutService,
    private pagerService: PagerService, public oTrpconsignment: Trpconsignment, public oTrpconsignmentinv: Trpconsignmentinv, public oGRbookingervice: GRbookingervice, private router: Router,
    private ActivatedRoute: ActivatedRoute, public ModelPartyMaster: PartyMaster, public _city: City, public oTrpcharges: Trpcharges, public trpvtcharges: Trptvcharges, public oApplicationcl: Applicationcl,
    public oGRBooking: GRBooking, public oUserMaster: UserMaster, private oPartysupplier: PartySuppliers, public oTrpPaidTopaycharge: TrpPaidTopaycharge, public oLocation: LocationMaster, public oLookupService: LookupService) {
    this.AutoLogoutService.CheckAuthentication();
    this.userId = parseInt(sessionStorage.getItem("userid"));
    this.RoleId = parseInt(sessionStorage.getItem("RoleId"));
    this.loccode = parseInt(sessionStorage.getItem("c"));
    // if (this.RoleId == 1 || this.RoleId == 2) { this.ISEditableCharges = true; }
    this.oTrpconsignment.CN_LOC = 0;
    this.oTrpconsignment.CN_TOLOC = 0;
    this.FullLoadVehicle = "0";
    this.PackingTypeSelected = "0";
    this.oTrpconsignment.CN_MODE = "1";
    this.LocationBankID = "0";
    this.oTrpconsignment.CN_DELI_INST = "0";
    this.oTrpconsignment.CN_FRT_MODE = "0";
    this.oTrpconsignment.PAY_MODE = "1";
    this.oTrpconsignmentinv.CN_BOXTYPE = "0";
    this.ModelPartyMaster.ACC_CITY = "0";
    this.ModelPartyMaster.ACC_BILLABLE = true;
    this.ModelPartyMaster.ACC_ACTIVE = true;
    this.LoginFullName = sessionStorage.getItem("fullname");
    this.ConsignorName = this.LoginFullName;
    this.PartyAccCode = sessionStorage.getItem("acccode");
    this.oTrpconsignment.CN_CRCODE = this.PartyAccCode;
    this.ConsignerDetail();
    this.CreatedByFullName = this.LoginFullName;
    this.GetBranchMaster();
    this.GETVehicleTypeList();
    this.GETPackingTypeList();
  }

  ngOnInit() {
    this.SetDefaultValue();
    //It is for autocomplete search box
    this.filteredOptions = this.myControl.valueChanges.pipe(startWith(''), map(value => this._filter(value)));
    this.filteredOptionConsignee = this.myControlConsignee.valueChanges.pipe(startWith(''), map(value => this._filterConsignee(value)));
    this.filteredOptionBiller = this.myControlBiller.valueChanges.pipe(startWith(''), map(value => this._filterBiller(value)));
    //End

    //this.EditGR();
  }

  public RESETUI() {
    this.lGreenTaxlist = [];
    this.InvoiceList = [];
    this.oTrpconsignment.CN_NO = undefined;
    this.oTrpconsignment.CN_REFNO = undefined;
    this.RefNo = undefined;
    this.oTrpconsignment.CN_TIME = undefined;
    this.oTrpconsignment.CN_COPY = undefined;

    this.oTrpconsignment.CN_CNCODE = undefined;
    this.oTrpconsignment.CN_NOB = 0;
    this.oTrpconsignment.CN_INVNO = undefined;
    this.oTrpconsignment.CN_INVVALUE = 0;
    this.oTrpconsignment.CN_PARTNO = undefined;
    this.oTrpconsignment.CN_QTY = 0;
    this.oTrpconsignment.CN_H = 0;
    this.oTrpconsignment.CN_L = 0;
    this.oTrpconsignment.CN_W = 0;
    this.oTrpconsignment.CN_CFT = 0;
    this.oTrpconsignment.CN_ACTWT = 0;
    this.oTrpconsignment.CN_CHGWT = 0;
    this.oTrpconsignment.CN_FREIGHT = 0;
    this.oTrpconsignment.CN_STCHG = 0;
    this.oTrpconsignment.CN_DTDCHG = 0;
    this.oTrpconsignment.CN_OTHCHG = 0;
    this.oTrpconsignment.CN_COLCHG = 0;
    this.oTrpconsignment.CN_MRNO = undefined;
    this.oTrpconsignment.CN_MRAMT = 0;
    this.oTrpconsignment.TDS_AMT = 0;
    this.oTrpconsignment.CN_REMARK = undefined;
    this.oTrpconsignment.CN_STATUS = undefined;
    this.oTrpconsignment.CN_UID = undefined;
    this.oTrpconsignment.CN_FRTONPKG = undefined;
    this.oTrpconsignment.CN_UNITFRT = 0;
    this.oTrpconsignment.CN_STPER = 0;
    this.oTrpconsignment.CN_ST = 0;
    this.oTrpconsignment.CN_DD = undefined;
    this.oTrpconsignment.CN_INVDATE = undefined;
    this.oTrpconsignment.CN_ITMDESC = undefined;
    this.oTrpconsignment.CN_BILLSTATUS = undefined;
    this.oTrpconsignment.CN_PWF = undefined;
    this.oTrpconsignment.CN_VT = undefined;
    this.oTrpconsignment.CN_NETVALUE = undefined;
    this.oTrpconsignment.CN_BILLPARTY = undefined;
    this.oTrpconsignment.CN_STPAYBY = undefined;
    this.oTrpconsignment.CN_PUBLISH = undefined;
    this.oTrpconsignment.CN_DDRCHARTNO = undefined;
    this.oTrpconsignment.EnrouteID = undefined;
    this.oTrpconsignment.CN_ADRNO = undefined;
    this.oTrpconsignment.CN_ADRDATE = undefined;
    this.oTrpconsignment.CN_HASPOD = undefined;
    this.oTrpconsignment.CN_SETTAMT = undefined;
    this.oTrpconsignment.CN_SETTSTATUS = undefined;
    this.oTrpconsignment.CN_ACTSTS = undefined;
    this.oTrpconsignment.CN_MRDATE = undefined;
    this.oTrpconsignment.CN_AGENCY = undefined;
    this.oTrpconsignment.CN_RUNSTATUS = undefined;
    this.oTrpconsignment.CN_EWAYBILLNO = undefined;
    this.oTrpconsignment.POD_STATUS = undefined;
    this.oTrpconsignment.GPS_STATUS = undefined;
    this.oTrpconsignment.VEH_NO = undefined;
    this.oTrpconsignment.MR_STATUS = undefined;
    this.oTrpconsignment.CN_RFU = undefined;
    this.oTrpconsignment.MR_REC_DATE = undefined;
    this.oTrpconsignment.CN_DELUID = undefined;
    this.oTrpconsignment.CHEQUE_NO = undefined;
    this.oTrpconsignment.CN_UPDATEBY = undefined;
    this.oTrpconsignment.CN_UPDATEDATE = undefined;
    this.oTrpconsignment.CN_EWAYEXPIRYDT = undefined;
    this.oTrpconsignment.CN_ENTRYDATE = undefined;
    this.oTrpconsignment.CN_SPLVEHCHG = 0;
    this.oTrpconsignment.CN_FOVPER = undefined;
    this.oTrpconsignment.CN_FOV = 0;
    this.oTrpconsignment.CN_INSTBY = undefined;
    this.oTrpconsignment.CN_ADRDT = undefined;
    this.oTrpconsignment.CN_RUNO = undefined;
    this.oTrpconsignment.CN_RUDATE = undefined;
    this.oTrpconsignment.CN_SHORT_QTY = undefined;
    this.oTrpconsignment.CN_SHORT_REMARK = undefined;
    this.oTrpconsignment.CN_BANKID = undefined;
    this.oTrpconsignment.CN_CHARGE1 = undefined;
    this.oTrpconsignment.CN_CHARGE2 = undefined;
    this.oTrpconsignment.NetTotal = 0;
    this.oTrpconsignment.GrandTotal = 0;
    this.oTrpconsignment.CN_UNLOAD_CHARGE = 0;
    this.oTrpconsignment.TOLL_CHARGE = 0;
    this.oTrpconsignment.DETENTION_CHARGE = 0;
    this.oTrpconsignment.IS_GRSUBMIT = false;
    this.oTrpconsignment.CN_MODE = "1";
    this.LocationBankID = "0";
    this.oTrpconsignment.CN_DELI_INST = "0";
    this.oTrpconsignment.CN_FRT_MODE = "0";
    this.oTrpconsignment.PAY_MODE = "1";
    this.oTrpconsignmentinv.CN_BOXTYPE = "0";
    this.oTrpconsignment.BILL_MOBILENO = undefined;
    this.oTrpconsignment.CN_GSTNO = undefined;
    this.oTrpconsignment.CR_GSTNO = undefined;
    this.LocationId = 0;
    this.IsPackage = false;
    this.IsTDS = false;
    this.IsWeight = true;
    this.FrightOnelected = "Weight";
    this.IsFull = false;
    this.IsFullLoad = false;
    this.ConsignerNameAddress = undefined;
    this.ConsigneeNameAddress = undefined;
    this.BillingPartyNameAddress = undefined;
    this.PackingTypeSelected = "0";
    this.LocationBankID = "0";
    this.myControl.setValue('');
    this.myControlConsignee.setValue('');
    this.myControlBiller.setValue('');
    this.InvoiceValidationResult = undefined;
    this.GRValidationResult = undefined;
    this.AddPartyValidationResult = undefined;
    this.IsGRGenerated = false;
    this.InvoiceList = [];
    this.pagedItems.length = 0;
    this.TotalInvoiceValue = 0;
    this.TotalInvoiceGST = 0;
    this.GreenTax = 0;
    this.IsUpdate = false;
    this.IsSubmit = true;
    this.GRNO = undefined;
    this.billingParty = undefined;
    this.AddPartyOption = 0;
    this.Mrgeneratedauto = false;
    this.FullLoadVehicle = "0";
    this.oTrpconsignment.VEH_NO = undefined;
    this.ModelPartyMaster.IS_GREENTAX_APPLICABLE = false;
    this.oApplicationcl.IsProgressBarEnable = false;
    this.IsDefaultChargeCalculate = true;
    this.ConsignorName = '';
    this.oTrpconsignment.CN_MOBILENO = undefined;
    this.oTrpconsignment.CR_MOBILENO = undefined;
    this.oTrpconsignment.BILL_MOBILENO = undefined;

    if (!this.IsFullLoad) {
      if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
        this.FillPaidToPayChargeDetail();
      }
      else {
        this.FillChargeDetail();
      }
    }
    else {
      this.FillFullLoadChargeDetail();
    }
  }

  public SetDefaultValue() {

    this.oTrpconsignment.CN_CNCODE = '';
    this.oTrpconsignment.CN_BILLPARTY = '';
    this.oTrpconsignment.BILL_MOBILENO = '';
    this.DefaultDate = new Date().toISOString().split('T')[ 0 ];
    this.oTrpconsignment.CREATED_DATE = this.DefaultDate;
    this.oTrpconsignment.CN_DATE = this.DefaultDate;
    this.oTrpconsignment.UPDATED_DATE = this.DefaultDate;
    this.oTrpconsignmentinv.CN_INVDATE = this.DefaultDate;
    this.oTrpconsignment.CN_MRAMT = 0;
    this.oTrpconsignment.TDS_AMT = 0;
    this.oTrpconsignmentinv.CN_INVVALUE = 0;
    this.oTrpconsignmentinv.CN_NOB = 0;
    this.oTrpconsignmentinv.CN_H = 0;
    this.oTrpconsignmentinv.CN_L = 0;
    this.oTrpconsignmentinv.CN_W = 0;
    this.oTrpconsignmentinv.CN_CFT = 0;
    this.oTrpconsignmentinv.CN_ACTWT = 0;
    this.oTrpconsignmentinv.CN_CHGWT = 0;
    this.oTrpconsignment.CN_UNITFRT = 0;
    this.oTrpconsignment.CN_FREIGHT = 0;
    this.oTrpconsignment.CN_STCHG = 0;
    this.oTrpconsignment.CN_COLCHG = 0;
    this.oTrpconsignment.CN_DTDCHG = 0;
    this.oTrpconsignment.CN_FOV = 0;
    this.oTrpconsignment.CN_SPLVEHCHG = 0;
    this.oTrpconsignment.CN_OTHCHG = 0;
    this.oTrpconsignment.CN_UNLOAD_CHARGE = 0;
    this.oTrpconsignment.TOLL_CHARGE = 0;
    this.oTrpconsignment.DETENTION_CHARGE = 0;
    this.oTrpconsignment.NetTotal = 0;
    this.oTrpconsignment.CN_ST = 0;
    this.oTrpconsignment.GrandTotal = 0;
    this.oTrpconsignment.CN_GSTNO = "";
    this.oTrpconsignment.CN_MOBILENO = "";
  }

  Submit(form: NgForm, input: number) {
    this.ValidateGR();
    if (this.GRValidationResult) {
      this.IsSubmit = false;
      this.PopulateGRUI();
      this.oApplicationcl.IsProgressBarEnable = true;
      this.oGRBooking.Consignment = this.oTrpconsignment;
      this.oGRBooking.ConsignmentInv = new Array<any>(this.InvoiceList.length);
      let Counter: number = 0;
      this.InvoiceList.forEach(element => {
        this.oTrpconsignmentinv = new Trpconsignmentinv();
        this.oTrpconsignmentinv.CN_INVOICE_ID = element.CNINVOICE_ID;
        this.oTrpconsignmentinv.CN_INVNO = element.CNINVNO;
        this.oTrpconsignmentinv.CN_LOC = element.CNLOC;
        this.oTrpconsignmentinv.CN_NO = element.CNNO;
        this.oTrpconsignmentinv.CN_INVDATE = element.CNINVDATE;
        this.oTrpconsignmentinv.CN_INVVALUE = element.CNINVVALUE;
        this.oTrpconsignmentinv.CN_NETVALUE = element.CNNETVALUE;
        this.oTrpconsignmentinv.CN_ITMDESC = element.CNITMDESC;
        this.oTrpconsignmentinv.CN_BOXTYPE = element.CNBOXTYPE;
        this.oTrpconsignmentinv.CN_NOB = element.CNNOB;
        this.oTrpconsignmentinv.CN_PARTNO = element.CNPARTNO;
        this.oTrpconsignmentinv.CN_QTY = element.CNQTY;
        this.oTrpconsignmentinv.CN_H = element.CNH;
        this.oTrpconsignmentinv.CN_L = element.CNL;
        this.oTrpconsignmentinv.CN_W = element.CNW;
        this.oTrpconsignmentinv.CN_CFT = element.CNCFT;
        this.oTrpconsignmentinv.CN_ACTWT = element.CNACTWT;
        this.oTrpconsignmentinv.CN_CHGWT = element.CNCHGWT;
        this.oTrpconsignmentinv.TS = element.TS;
        this.oTrpconsignmentinv.CN_EWAYBILLNO = element.CNEWAYBILLNO;
        this.oTrpconsignmentinv.CN_EWAYEXPIRYDT = element.CNEWAYEXPIRYDT;
        this.oTrpconsignmentinv.CN_PARTNO2 = element.CNPARTNO2;
        this.oTrpconsignmentinv.CN_PARTNO3 = element.CNPARTNO3;
        this.oTrpconsignmentinv.CN_PARTQTY1 = element.CNPARTQTY1;
        this.oTrpconsignmentinv.CN_PARTQTY2 = element.CNPARTQTY2;
        this.oTrpconsignmentinv.CN_PARTQTY3 = element.CNPARTQTY3;
        this.oTrpconsignmentinv.CREATEDBY_USERID = element.CREATEDBYUSERID;
        this.oTrpconsignmentinv.UPDATEDBY_USERID = element.UPDATEDBYUSERID;
        this.oTrpconsignmentinv.CREATED_DATE = element.CREATEDDATE;
        this.oTrpconsignmentinv.UPDATED_DATE = element.UPDATEDDATE;
        this.oTrpconsignmentinv.IS_ACTIVE = element.ISACTIVE;
        this.oGRBooking.ConsignmentInv[ Counter ] = this.oTrpconsignmentinv;
        Counter += 1;
      });
      Counter = 0;
      this.oGRbookingervice.SubmitWebGR(this.oGRBooking).subscribe(
        data => {
          this.IsSubmit = false;
          let oServiceStatus: ServiceStatus = data;
          if (oServiceStatus.Status == ResponseCode.SaveSuccessFully.toString()) {
            let cnno = oServiceStatus.ErrorMessage;
            if (input == 1) {
              alert("Record saved successfully! Your GR no is : " + cnno);
              this.RESETUI();
              this.ResetInvoiceControl();
              this.oGRBooking.ConsignmentInv = [];
              window.scrollTo(0, 0);
            }
            else if (input == 2) {
              let podcopy: string = "n";
              let CRCopy: string = "n";
              let CNCopy: string = "n";

              if (this.bCRCopy) {
                CRCopy = "y";
              }
              window.open(environment.MvcWebUrl + "ReportViewer.aspx?ReportType=ConsignmentPrint&FromCNNo=" + cnno + "&ToCNNo=" + cnno + "&PODCopy=" + podcopy + "&CRCopy=" + CRCopy + "&CNCopy=" + CNCopy + "&Mail=n");

              this.RESETUI();
              this.ResetInvoiceControl();
              this.oGRBooking.ConsignmentInv = [];
              alert("Record saved successfully! Your GR no is : " + cnno);
              window.scrollTo(0, 0);
            }
          }
          else {
            // this.alerts.setDefaults('timeout', 30);
            // this.alerts.setMessage(oServiceStatus.ErrorMessage, 'error');
            alert(oServiceStatus.ErrorMessage);
            this.oGRBooking.ConsignmentInv = [];
            this.oApplicationcl.IsProgressBarEnable = false;
            this.IsSubmit = true;
          }
        })
    }
  }

  public Print() {
    let podcopy: string = "n";
    let CRCopy: string = "n";
    let CNCopy: string = "n";
    if (this.bPODCopy) {
      podcopy = "y";
    }
    if (this.bCRCopy) {
      CRCopy = "y";
    }
    if (this.bCNCopy) {
      CNCopy = "y";
    }
    window.open(environment.MvcWebUrl + "ReportViewer.aspx?ReportType=ConsignmentPrint&FromCNNo=" + this.GRNO + "&ToCNNo=" + this.GRNO + "&PODCopy=" + podcopy + "&CRCopy=" + CRCopy + "&CNCopy=" + CNCopy + "&Mail=n");
  }

  public ResetForm(form: NgForm) {
    this.router.navigateByUrl('Resetui?id=grbooking');
  }

  public AddInvoice() {
    if (this.IsUpdate && this.oTrpconsignment.CN_STATUS != 'P' && (this.RoleId != 1 && this.RoleId != 7 && this.RoleId != 5 && this.RoleId != 9)) {
      alert("Update not allowed after challan generated");
      return;
    }
    else if (this.IsUpdate && this.oTrpconsignment.CN_STATUS != 'P' && (this.RoleId == 1 || this.RoleId == 7 || this.RoleId == 5 || this.RoleId == 9)) {
      this.IsDefaultChargeCalculate = true;
      this.InvoiceEntry();
    }
    else if (this.IsUpdate && this.oTrpconsignment.CN_STATUS == 'P') {
      this.IsDefaultChargeCalculate = true;
      this.InvoiceEntry();
    }

    if (this.IsSubmit) {
      this.IsDefaultChargeCalculate = true;
      this.InvoiceEntry();
    }
  }

  public InvoiceEntry() {
    this.oTrpconsignmentinv.CN_CHGWT = this.oTrpconsignmentinv.CN_ACTWT;
    this.validateInvoiceControls();
    if (this.InvoiceValidationResult) {
      this.populateInvoiceUI();
      if (this.ISEditInvoice) {
        this.InvoiceList.forEach(element => {
          if (this.SelectedInvoiceId == element.InvoiceId) {
            element.CNINVOICE_ID = this.oTrpconsignmentinv.CN_INVOICE_ID; element.CNLOC = this.oTrpconsignmentinv.CN_LOC; element.CNNO = this.oTrpconsignmentinv.CN_NO;
            element.CNINVNO = this.oTrpconsignmentinv.CN_INVNO; element.CNINVDATE = this.oTrpconsignmentinv.CN_INVDATE; element.CNINVVALUE = this.oTrpconsignmentinv.CN_INVVALUE;
            element.CNNETVALUE = this.oTrpconsignmentinv.CN_NETVALUE; element.CNITMDESC = this.oTrpconsignmentinv.CN_ITMDESC; element.CNBOXTYPE = this.oTrpconsignmentinv.CN_BOXTYPE;
            element.CNNOB = this.oTrpconsignmentinv.CN_NOB; element.CNPARTNO = this.oTrpconsignmentinv.CN_PARTNO; element.CNQTY = this.oTrpconsignmentinv.CN_QTY; element.CNH = this.oTrpconsignmentinv.CN_H;
            element.CNL = this.oTrpconsignmentinv.CN_L; element.CNW = this.oTrpconsignmentinv.CN_W; element.CNCFT = this.oTrpconsignmentinv.CN_CFT; element.CNACTWT = this.oTrpconsignmentinv.CN_ACTWT; element.CNCHGWT = this.oTrpconsignmentinv.CN_CHGWT;
            element.TS = this.oTrpconsignmentinv.TS; element.CNEWAYBILLNO = this.oTrpconsignmentinv.CN_EWAYBILLNO; element.CNEWAYEXPIRYDT = this.oTrpconsignmentinv.CN_EWAYEXPIRYDT; element.CNPARTNO2 = this.oTrpconsignmentinv.CN_PARTNO2;
            element.CNPARTNO3 = this.oTrpconsignmentinv.CN_PARTNO3; element.CNPARTQTY1 = this.oTrpconsignmentinv.CN_PARTQTY1; element.CNPARTQTY2 = this.oTrpconsignmentinv.CN_PARTQTY2; element.CNPARTQTY3 = this.oTrpconsignmentinv.CN_PARTQTY3;
            element.CREATEDBYUSERID = this.oTrpconsignmentinv.CREATEDBY_USERID; element.UPDATEDBYUSERID = this.oTrpconsignmentinv.UPDATEDBY_USERID; element.CREATEDDATE = this.oTrpconsignmentinv.CREATED_DATE; element.UPDATEDDATE = this.oTrpconsignmentinv.UPDATED_DATE;
            element.ISACTIVE = this.oTrpconsignmentinv.IS_ACTIVE;
          }
        });
        this.oTrpconsignment.CN_CHGWT = 0;
        this.ISEditInvoice = false;
      } else {
        let arr: any[] = [ {
          InvoiceId: this.InvoiceId,
          CNINVOICE_ID: this.oTrpconsignmentinv.CN_INVOICE_ID, CNLOC: this.oTrpconsignmentinv.CN_LOC, CNNO: this.oTrpconsignmentinv.CN_NO,
          CNINVNO: this.oTrpconsignmentinv.CN_INVNO, CNINVDATE: this.oTrpconsignmentinv.CN_INVDATE, CNINVVALUE: this.oTrpconsignmentinv.CN_INVVALUE,
          CNNETVALUE: this.oTrpconsignmentinv.CN_NETVALUE, CNITMDESC: this.oTrpconsignmentinv.CN_ITMDESC, CNBOXTYPE: this.oTrpconsignmentinv.CN_BOXTYPE,
          CNNOB: this.oTrpconsignmentinv.CN_NOB, CNPARTNO: this.oTrpconsignmentinv.CN_PARTNO, CNQTY: this.oTrpconsignmentinv.CN_QTY, CNH: this.oTrpconsignmentinv.CN_H,
          CNL: this.oTrpconsignmentinv.CN_L, CNW: this.oTrpconsignmentinv.CN_W, CNCFT: this.oTrpconsignmentinv.CN_CFT, CNACTWT: this.oTrpconsignmentinv.CN_ACTWT, CNCHGWT: this.oTrpconsignmentinv.CN_CHGWT,
          TS: this.oTrpconsignmentinv.TS, CNEWAYBILLNO: this.oTrpconsignmentinv.CN_EWAYBILLNO, CNEWAYEXPIRYDT: this.oTrpconsignmentinv.CN_EWAYEXPIRYDT, CNPARTNO2: this.oTrpconsignmentinv.CN_PARTNO2,
          CNPARTNO3: this.oTrpconsignmentinv.CN_PARTNO3, CNPARTQTY1: this.oTrpconsignmentinv.CN_PARTQTY1, CNPARTQTY2: this.oTrpconsignmentinv.CN_PARTQTY2, CNPARTQTY3: this.oTrpconsignmentinv.CN_PARTQTY3,
          CREATEDBYUSERID: this.oTrpconsignmentinv.CREATEDBY_USERID, UPDATEDBYUSERID: this.oTrpconsignmentinv.UPDATEDBY_USERID, CREATEDDATE: this.oTrpconsignmentinv.CREATED_DATE, UPDATEDDATE: this.oTrpconsignmentinv.UPDATED_DATE,
          ISACTIVE: this.oTrpconsignmentinv.IS_ACTIVE
        } ];
        this.InvoiceList.push(arr[ 0 ]);
        this.InvoiceId += 1;
      }
      this.setPage(1);
      this.TextboxChargeCalculate(null);
      //------calculate slab charge-----------------------------
      this.PopulateGRUI();

      if (this.oTrpconsignment.CN_PWF == 'W' && this.oTrpcharges.MIN_WEIGHT != 0 && this.oTrpconsignment.CN_CHGWT < this.oTrpcharges.MIN_WEIGHT) {
        this.oTrpconsignment.CN_CHGWT = this.oTrpcharges.MIN_WEIGHT;
        this.TextboxChargeCalculate(null);
      }
      if (this.oTrpcharges.WEIGHT_SLAB > 1 && this.oTrpconsignment.CN_PWF == 'W') {
        let mode: number = 0;
        let conweight: number = this.oTrpconsignment.CN_CHGWT < this.oTrpcharges.WEIGHT_SLAB ? this.oTrpcharges.WEIGHT_SLAB : this.oTrpconsignment.CN_CHGWT;
        mode = conweight % this.oTrpcharges.WEIGHT_SLAB;
        if (mode > 0) {
          this.oTrpconsignment.CN_CHGWT = conweight + (this.oTrpcharges.WEIGHT_SLAB - mode);
          this.TextboxChargeCalculate(null);
        }
      }
      if (this.oTrpcharges.MIN_FREIGHT != 0 && this.oTrpconsignment.CN_FREIGHT < this.oTrpcharges.MIN_FREIGHT) {
        this.oTrpconsignment.CN_FREIGHT = this.oTrpcharges.MIN_FREIGHT;
        this.TextboxChargeCalculate(null);
      }

      //----------------------------End---------------------------
      this.ResetInvoiceControl();
    }
  }

  public ResetInvoiceControl() {
    this.DefaultDate = new Date().toISOString().split('T')[ 0 ];
    this.oTrpconsignmentinv.CN_INVDATE = this.DefaultDate;
    this.oTrpconsignmentinv.CN_INVVALUE = 0;
    this.oTrpconsignmentinv.CN_EWAYBILLNO = "";
    this.oTrpconsignmentinv.CN_EWAYEXPIRYDT = undefined;
    this.oTrpconsignmentinv.CN_BOXTYPE = "0";
    this.oTrpconsignmentinv.CN_NOB = 0;
    this.oTrpconsignmentinv.CN_PARTNO = "";
    this.oTrpconsignmentinv.CN_ITMDESC = "";
    this.oTrpconsignmentinv.CN_QTY = 0;
    this.oTrpconsignmentinv.CN_H = 0;
    this.oTrpconsignmentinv.CN_L = 0;
    this.oTrpconsignmentinv.CN_W = 0;
    this.oTrpconsignmentinv.CN_CFT = 0;
    this.oTrpconsignmentinv.CN_ACTWT = 0;
    this.oTrpconsignmentinv.CN_CHGWT = 0;
    this.oTrpconsignmentinv.CN_INVNO = undefined;
  }

  private populateInvoiceUI() {

    if (this.oTrpconsignmentinv.CN_EWAYBILLNO == "0" && this.oTrpconsignmentinv.CN_EWAYBILLNO == undefined) {
      this.oTrpconsignment.CN_EWAYEXPIRYDT = null;
    }
    this.DefaultDate = new Date().toISOString().split('T')[ 0 ];
    this.oTrpconsignmentinv.CREATED_DATE = this.DefaultDate;
    this.oTrpconsignmentinv.UPDATED_DATE = this.DefaultDate;
    this.oTrpconsignmentinv.CREATEDBY_USERID = this.userId;
    this.oTrpconsignmentinv.UPDATEDBY_USERID = this.userId;
    this.oTrpconsignmentinv.IS_ACTIVE = true;
    this.oTrpconsignmentinv.CN_LOC = this.oTrpconsignment.CN_LOC.toString();
    this.oTrpconsignmentinv.CN_NETVALUE = this.oTrpconsignmentinv.CN_INVVALUE;
    if (this.FrightOnelected == "Quantity") {
      this.oTrpconsignment.CN_FRTONPKG = false;
      this.oTrpconsignment.CN_PWF = "Q";
    }
    else if (this.FrightOnelected == "Packages") {
      this.oTrpconsignment.CN_FRTONPKG = true;
      this.oTrpconsignment.CN_PWF = "P";
    }
    else if (this.FrightOnelected == "Weight") {
      this.oTrpconsignment.CN_FRTONPKG = false;
      this.oTrpconsignment.CN_PWF = "W";
    }
    else if (this.FrightOnelected == "FullLoad") {
      this.oTrpconsignment.CN_FRTONPKG = false;
      this.oTrpconsignment.CN_PWF = "F";
    }
  }
  private validateInvoiceControls() {
    this.alerts.setDefaults('timeout', 5);
    if (this.oTrpconsignment.CN_LOC == 0 || this.oTrpconsignment.CN_LOC == undefined) {
      this.commonservice.focusInput(document.getElementById('ddlLocation'));
      this.alerts.setMessage('Please select from branch', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignment.CN_TOLOC == 0 || this.oTrpconsignment.CN_TOLOC == undefined) {
      this.commonservice.focusInput(document.getElementById('ddtolLocation'));
      this.alerts.setMessage('Please select To branch', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignment.CN_MODE == "0" || this.oTrpconsignment.CN_MODE == undefined) {
      this.commonservice.focusInput(document.getElementById('ddlMode'));
      this.alerts.setMessage('Mode is required', 'error');
      this.InvoiceValidationResult = false;
      return;

    }
    else if (this.oTrpconsignment.CN_FRT_MODE == "0" || this.oTrpconsignment.CN_FRT_MODE == undefined) {
      this.commonservice.focusInput(document.getElementById('ddlFRTMode'));
      this.alerts.setMessage('Freight Type required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignment.CN_DELI_INST == "0" || this.oTrpconsignment.CN_DELI_INST == undefined) {
      this.commonservice.focusInput(document.getElementById('ddlDeliveryType'));
      this.alerts.setMessage('Delivery Type required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignment.CN_CRCODE == "" || this.oTrpconsignment.CN_CRCODE == undefined) {
      this.commonservice.focusInput(document.getElementById('txtConsigner'));
      this.alerts.setMessage('Consignor required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignment.CN_CNCODE == "0" || this.oTrpconsignment.CN_CNCODE == undefined) {
      this.commonservice.focusInput(document.getElementById('txtConsignee'));
      this.alerts.setMessage('Consignee required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignment.CN_FRT_MODE != "7" && (this.oTrpconsignment.CN_BILLPARTY == "" || this.oTrpconsignment.CN_BILLPARTY == undefined)) {
      this.commonservice.focusInput(document.getElementById('txtBillingParty'));
      this.alerts.setMessage('Billing Party required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignmentinv.CN_INVNO == "0" || this.oTrpconsignmentinv.CN_INVNO == undefined) {
      this.commonservice.focusInput(document.getElementById('txtInvoiceNo'));
      this.alerts.setMessage('Invoice No required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignmentinv.CN_INVVALUE == undefined) {
      this.commonservice.focusInput(document.getElementById('txtInvoiceValue'));
      this.alerts.setMessage('Invoice value should not be empty', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if (this.oTrpconsignmentinv.CN_EWAYBILLNO != "" && this.oTrpconsignmentinv.CN_EWAYBILLNO != undefined && (this.oTrpconsignmentinv.CN_EWAYEXPIRYDT == "" || this.oTrpconsignmentinv.CN_EWAYEXPIRYDT == undefined)) {
      this.commonservice.focusInput(document.getElementById('txteWBExpiryDt'));
      this.alerts.setMessage('e-Way expiry date required', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else {
      this.InvoiceValidationResult = true;
    }


    if (this.FrightOnelected == "Packages") {

      if (this.oTrpconsignmentinv.CN_BOXTYPE == "" || this.oTrpconsignmentinv.CN_BOXTYPE == undefined) {
        this.commonservice.focusInput(document.getElementById('ddlPackingType'));
        this.alerts.setMessage('Packing Type required', 'error');
        this.InvoiceValidationResult = false;
        return;
      }
      // else if (this.oTrpconsignmentinv.CN_NOB == 0 || this.oTrpconsignmentinv.CN_NOB == undefined) {

      //   this.commonservice.focusInput(document.getElementById('txtNoOfPackage'));
      //   this.alerts.setMessage('No of Package should be not be empty', 'error');
      //   this.InvoiceValidationResult = false;
      //   return;
      // }

    }
    else if (this.FrightOnelected == "Weight") {
      // if (this.oTrpconsignmentinv.CN_CHGWT == 0 || this.oTrpconsignmentinv.CN_CHGWT == undefined) {
      //   this.alerts.setMessage('Charge weight should not be empty', 'error');
      //   this.commonservice.focusInput(document.getElementById('txtChargeweight'));
      //   this.InvoiceValidationResult = false;
      //   return;
      // }
    }
    else if (this.FrightOnelected == "FullLoad") {
      if (this.FullLoadVehicle == "0" || this.FullLoadVehicle == undefined) {
        this.commonservice.focusInput(document.getElementById('ddlVehicleType'));
        this.alerts.setMessage('Vehicle type required', 'error');
        this.InvoiceValidationResult = false;
        return;
      }
      if (this.oTrpconsignment.VEH_NO == "" || this.oTrpconsignment.VEH_NO == undefined) {
        this.commonservice.focusInput(document.getElementById('txtFullLoadVNo'));
        this.alerts.setMessage('Vehicle no required', 'error');
        this.InvoiceValidationResult = false;
        return;
      }
      else if (this.oTrpconsignmentinv.CN_BOXTYPE == "0" || this.oTrpconsignmentinv.CN_BOXTYPE == undefined) {
        this.commonservice.focusInput(document.getElementById('ddlPackingType'));
        this.alerts.setMessage('Packing Type required', 'error');
        this.InvoiceValidationResult = false;
        return;
      }
      if ((this.oTrpconsignmentinv.CN_NOB == 0 || this.oTrpconsignmentinv.CN_NOB == undefined) && ((this.oTrpconsignmentinv.CN_CHGWT <= 0 || this.oTrpconsignmentinv.CN_CHGWT == undefined))) {
        this.commonservice.focusInput(document.getElementById('txtNoOfPackage'));
        this.alerts.setMessage('Either No of Package or Charge weight should be greater than 0', 'error');
        this.InvoiceValidationResult = false;
        return;
      }
    }
    else {
      this.InvoiceValidationResult = true;
    }

    if ((this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "3" || this.oTrpconsignment.CN_FRT_MODE == "6") && this.oTrpconsignment.CN_CRCODE != this.oTrpconsignment.CN_BILLPARTY) {
      this.commonservice.focusInput(document.getElementById('txtBillingParty'));
      this.alerts.setMessage('Billing Party should be consignor', 'error');
      this.InvoiceValidationResult = false;
      return;
    }
    else if ((this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "4") && this.oTrpconsignment.CN_CNCODE != this.oTrpconsignment.CN_BILLPARTY) {
      this.commonservice.focusInput(document.getElementById('txtBillingParty'));
      this.alerts.setMessage('Billing Party should be consignee', 'error');
      this.InvoiceValidationResult = false;
    }
    else {
      this.InvoiceValidationResult = true;
    }
  }

  private ValidateGR() {
    this.alerts.setDefaults('timeout', 5);
    if (this.InvoiceList == undefined || this.InvoiceList == null || this.InvoiceList.length == 0) {
      this.commonservice.focusInput(document.getElementById('txtInvoiceValue'));
      this.alerts.setMessage('Minimum one invoice required', 'error');
      window.scrollTo(0, 0);
      this.GRValidationResult = false;
      return;
    }
    // else if ((this.oTrpconsignment.CN_FREIGHT == 0 || this.oTrpconsignment.CN_FREIGHT == undefined) && this.oTrpconsignment.CN_FRT_MODE != "7") {
    //   this.commonservice.focusInput(document.getElementById('txtBasicFreight'));
    //   this.alerts.setMessage('Basic freight required. Please contact to administrator', 'error');
    //   this.GRValidationResult = false;
    //   return;
    // }
    // else if ((this.oTrpconsignment.NetTotal == 0 || this.oTrpconsignment.NetTotal == undefined) && this.oTrpconsignment.CN_FRT_MODE != "7") {
    //   this.commonservice.focusInput(document.getElementById('txtTotal'));
    //   this.alerts.setMessage('Total amount should be greater than 0', 'error');
    //   this.GRValidationResult = false;
    //   return;
    // }
    // else if (this.RefNo == "" || this.RefNo == undefined) {
    //   this.commonservice.focusInput(document.getElementById('txtManualRefNo'));
    //   this.alerts.setMessage('Manual ref no required', 'error');
    //   this.GRValidationResult = false;
    //   return;
    // }
    else if (this.oTrpconsignment.CN_CNCODE == "" || isNullOrUndefined(this.oTrpconsignment.CN_CNCODE)) {
      this.commonservice.focusInput(document.getElementById('txtConsignee'));
      this.alerts.setMessage('Consignee required', 'error');
      this.GRValidationResult = false;
      return;
    }
    else {
      this.GRValidationResult = true;
    }
  }

  private PopulateGRUI() {
    this.oTrpconsignment.CN_NO = this.GRNO;
    this.oTrpconsignment.CN_REFNO = this.RefNoPrefix + '-' + this.RefNo;
    this.oTrpconsignment.CN_BANKID = this.LocationBankID;
    if (!this.IsUpdate) {
      this.oTrpconsignment.CREATEDBY_USERID = this.userId;
    }
    this.oTrpconsignment.UPDATEDBY_USERID = this.userId;
    this.oTrpconsignment.IS_ACTIVE = true;
    this.oTrpconsignment.CN_BILLSTATUS = "P";
    this.oTrpconsignment.IS_GRSUBMIT = true;
    if (this.FrightOnelected == "Quantity") {
      this.oTrpconsignment.CN_FRTONPKG = false;
      this.oTrpconsignment.CN_PWF = "Q";
    }
    else if (this.FrightOnelected == "Packages") {
      this.oTrpconsignment.CN_FRTONPKG = true;
      this.oTrpconsignment.CN_PWF = "P";
    }
    else if (this.FrightOnelected == "Weight") {
      this.oTrpconsignment.CN_FRTONPKG = false;
      this.oTrpconsignment.CN_PWF = "W";
    }
    else if (this.FrightOnelected == "FullLoad") {
      this.oTrpconsignment.CN_FRTONPKG = false;
      this.oTrpconsignment.CN_PWF = "F";
    }
    this.oTrpconsignment.CN_VT = this.FullLoadVehicle;
    let QTY: number = 0;
    let NOB: number = 0;
    let ActWT: number = 0;
    let ChgWT: number = 0;
    let InvVal: number = 0;
    let NetVal: number = 0;
    if (this.InvoiceList != undefined) {
      this.InvoiceList.forEach((e: any) => {
        QTY = QTY + Number(e.CNQTY);
        NOB = NOB + Number(e.CNNOB);
        ChgWT = ChgWT + Number(e.CNCHGWT);
        ActWT = ActWT + Number(e.CNACTWT);
        InvVal = InvVal + Number(e.CNINVVALUE);
        NetVal = NetVal + Number(e.CNNETVALUE);
      });
    }
    this.oTrpconsignment.CN_INVVALUE = InvVal;
    this.oTrpconsignment.CN_NETVALUE = NetVal.toString();
    this.oTrpconsignment.CN_QTY = QTY;
    this.oTrpconsignment.CN_NOB = NOB;
    this.oTrpconsignment.CN_ACTWT = ActWT;
    if (this.oTrpconsignment.CN_CHGWT == undefined) {
      this.oTrpconsignment.CN_CHGWT = 0;
    }
    if (this.oTrpconsignment.CN_CHGWT < ChgWT) {
      this.oTrpconsignment.CN_CHGWT = ChgWT;
    }

    if (this.oTrpconsignment.CN_FRT_MODE != "1") {
      this.oTrpconsignment.CN_MRAMT = 0;
      this.oTrpconsignment.TDS_AMT = 0;
      this.oTrpconsignment.CN_MRNO = "";
    }
  }


  //It is for autocomplete search box
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.Consigneroptions.filter(option => option.toLowerCase().includes(filterValue));
    //return this.partylist.filter(option => option.ACC_NAME.toLowerCase().includes(filterValue));
  }
  private _filterConsignee(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.Consigneeoptions.filter(option => option.toLowerCase().includes(filterValue));
  }
  private _filterBiller(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.BillerOptions.filter(option => option.toLowerCase().includes(filterValue));
  }
  //End

  private GETPackingTypeList() {
    this.oMasterConfigrationService.GETPackingTypeList().subscribe(
      data => {
        this.PackingType = data;
        //console.log(this.VehicleType);
      });
  }

  private GetLocationBank(locationId: number) {
    this._service.GetLedgerBank(locationId).subscribe(
      data => {
        //console.log(data);
        this.Banks = data;
        this.Banks = this.Banks.filter(x => x.LEDGER_CODE == 'ACC_9491');
      });
  }

  GetPartyList() {
    this.oMasterConfigrationService.GetPartyForDDL(5, 0, "").subscribe(
      data => {
        this.partylist = data;
        this.Consigneroptions = [];
        this.partylist.forEach(element => {
          this.Consigneroptions.push(element.ACC_CODE + ":" + element.ACC_NAME);
        });
        if (this.IsSubmit) {
          this.myControl.setValue('a');
          this.myControl.setValue('');
        }
      });
  }


  GetBranchMaster() {
    this.oMasterConfigrationService.GetBranchMaster().subscribe(
      data => {
        this.ToLocations = data;
        this.FromLocations = data;
        // this._service.GetUserBranchForAccess(this.userId).subscribe(data2 => {
        //   let UserLoc = data2;
        //   if (!isNullOrUndefined(UserLoc) && UserLoc.length > 0) {
        //     UserLoc.forEach(element => {
        //       let loc = this.ToLocations.filter(x => x.ID == element.ID);
        //       this.FromLocations.push(loc[ 0 ]);
        //     });
        //   }
        //});
      });
  }

  GETVehicleTypeList() {
    this.oMasterConfigrationService.GETVehicleTypeList().subscribe(
      data => {
        this.VehicleType = data;
        //console.log(this.VehicleType);
      });
  }

  ClickFullLoad(evt: any) {
    this.IsDefaultChargeCalculate = true;
    if (this.IsUpdate) {
      this.IsFreightTypeChange = true;
    }
    let totalQtyBox: number = 0;
    let totalWeight: number = 0;
    if (this.InvoiceList != undefined) {
      this.InvoiceList.forEach((e: any) => {
        totalQtyBox = totalQtyBox + Number(e.CN_NOB);
      });
    }
    if (this.InvoiceList != undefined) {
      this.InvoiceList.forEach((e: any) => {
        totalWeight = totalWeight + Number(e.CN_CHGWT);
      });
    }

    var target = evt.target;

    if (target.checked) {
      if (evt.target.id == "Packages") {
        if (this.InvoiceList != null && this.InvoiceList.length > 0 && totalWeight > 0) {
          alert('Some invoice already added. Please delete befor change Freight On');
          return false;
        }
        else {
          this.IsPackage = true;
          this.IsWeight = false;
          this.IsFullLoad = false;
          if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
            this.FillPaidToPayChargeDetail();
          } else {
            this.FillChargeDetail();
          }
        }
      }
      else if (evt.target.id == "Weight") {
        if (this.InvoiceList != null && this.InvoiceList.length > 0 && totalQtyBox > 0) {
          alert('Some invoice already added. Please delete befor change Freight On');
          return false;
        }
        else {
          this.IsPackage = false;
          this.IsFullLoad = false;
          this.IsWeight = true;
          if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
            this.FillPaidToPayChargeDetail();
          } else {
            this.FillChargeDetail();
          }
        }
      }
      else if (evt.target.id == "FullLoad") {
        // if (this.InvoiceList != null && this.InvoiceList.length > 0) {
        //   alert('Some invoice already added. Please delete befor change Freight On');
        //   return false;
        // }
        // else {
        this.IsFullLoad = true;
        this.IsPackage = false;
        this.IsWeight = false;
        this.FillFullLoadChargeDetail();
        // }
      }
      else {
        this.IsFullLoad = false;
      }
      this.FrightOnelected = evt.target.id;
    }
  }

  public VehicleSelected(input: any) {
    if (this.FullLoadVehicle != "0") {
      this.IsDefaultChargeCalculate = true;
      this.IsFreightTypeChange = true;
      this.FillFullLoadChargeDetail();
    }
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.InvoiceList.length, page, 10);
    this.pagedItems = this.InvoiceList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    //console.log(this.pagedItems);
  }

  public selectedchangedLocation(input: any) {
    this.IsDefaultChargeCalculate = true;
    if (!this.IsGRGenerated) {
    }
    if (!this.IsFullLoad) {
      if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
        this.FillPaidToPayChargeDetail();
      } else {
        this.FillChargeDetail();
      }
    }
    else {
      this.FillFullLoadChargeDetail();
    }
  }

  public selectedchangedToLocation(input: any) {
    this.IsDefaultChargeCalculate = true;
    if (!this.IsFullLoad) {
      if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
        this.FillPaidToPayChargeDetail();
      } else {
        this.FillChargeDetail();
      }
    }
    else {
      this.FillFullLoadChargeDetail();
    }
  }

  public selectedchangedMode(input: any) {
    this.IsDefaultChargeCalculate = true;
    if (!this.IsFullLoad) {
      if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
        this.FillPaidToPayChargeDetail();
      } else {
        this.FillChargeDetail();
      }
    }
    else {
      this.FillFullLoadChargeDetail();
    }
  }

  public ConsignerDetail() {
    this.oMasterConfigrationService.GetSinglePartyRecord(this.PartyAccCode).subscribe(
      data3 => {
        this.oTrpconsignment.CR_GSTNO = data3.ACC_CSTNO;
        this.oTrpconsignment.CR_MOBILENO = data3.ACC_MOBILE1;
        this.oTrpconsignment.BILL_MOBILENO = data3.ACC_MOBILE1;
        this.oMasterConfigrationService.GetPartyForDDL(2, 0, this.PartyAccCode).subscribe(
          data => {
            this.PartySuppliers = [];
            this.Consigneeoptions = [];
            this.PartySuppliers = data;
            this.PartySuppliers.forEach(element => {
              this.Consigneeoptions.push(element.ACC_CODE + ":" + element.ACC_NAME);
            });
            this.myControlConsignee.setValue('a');
            this.myControlConsignee.setValue('');
          });
      });
  }

  public FillChargeDetail() {
    if (this.oTrpconsignment.CN_BILLPARTY != '' && this.oTrpconsignment.CN_BILLPARTY != undefined && this.oTrpconsignment.CN_FRT_MODE != "7") {
      this.oMasterConfigrationService.GetGreenTaxByLOC(this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC).subscribe(
        data1 => {
          this.lGreenTaxlist = data1;
          //console.log(this.lGreenTaxlist);
          this.oMasterConfigrationService.GetChargesForGRBooking(this.oTrpconsignment.CN_BILLPARTY, this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC, parseInt(this.oTrpconsignment.CN_MODE)).subscribe(
            data => {
              // console.log(data);
              if (!this.IsUpdate || this.IsFreightTypeChange) {
                this.oTrpconsignment.CN_UNITFRT = 0;
                this.oTrpconsignment.CN_STCHG = 0;
                this.oTrpconsignment.CN_COLCHG = 0;
                this.oTrpconsignment.CN_DTDCHG = 0;
                this.oTrpconsignment.CN_FOV = 0;
                this.oTrpconsignment.CN_SPLVEHCHG = 0;
                this.oTrpconsignment.CN_FREIGHT = 0;
                this.oTrpconsignment.CN_ST = 0;
              }
              if (data[ 'Message' ] != "Record not found") {
                this.oTrpcharges = data;
                //console.log(this.oTrpcharges);
                if (this.oTrpcharges != null) {
                  if (parseFloat(isNullOrUndefined(this.oTrpcharges.FRT_PKG) ? "0" : this.oTrpcharges.FRT_PKG.toString()) > 0) {
                    this.IsPackage = true;
                    this.IsWeight = false;
                    this.IsFullLoad = false;
                    this.FrightOnelected = "Packages";
                    this.oTrpconsignment.CN_UNITFRT = this.oTrpcharges.FRT_PKG;
                  }
                  else if (parseFloat(isNullOrUndefined(this.oTrpcharges.FRT_WT) ? "0" : this.oTrpcharges.FRT_WT.toString()) > 0) {
                    this.IsWeight = true;
                    this.IsPackage = false;
                    this.IsFullLoad = false;
                    this.FrightOnelected = "Weight";
                    this.oTrpconsignment.CN_UNITFRT = this.oTrpcharges.FRT_WT;
                  }
                  if (!this.IsUpdate || this.IsFreightTypeChange) {
                    this.oTrpconsignment.CN_STCHG = this.oTrpcharges.ST_CRG;
                    this.oTrpconsignment.CN_COLCHG = this.oTrpcharges.CLC_CRG;
                    this.oTrpconsignment.CN_DTDCHG = this.oTrpcharges.DD_CRG;
                    this.oTrpconsignment.CN_SPLVEHCHG = this.oTrpcharges.CN_SPLVEHCHG;
                  }
                  this.labourBasecharge = this.oTrpcharges.SRV_CRG;
                  this.oTrpcharges.WEIGHT_SLAB = isNullOrUndefined(this.oTrpcharges.WEIGHT_SLAB) ? 0 : this.oTrpcharges.WEIGHT_SLAB;

                  if (!this.IsUpdate) {
                    this.oTrpconsignment.CN_ST = 0;
                  }
                  if (!isNullOrUndefined(this.oTrpcharges.GREEN_TAX) && !isNaN(this.oTrpcharges.GREEN_TAX) && this.oTrpcharges.GREEN_TAX > 0) {
                    if (this.ModelPartyMaster.IS_GREENTAX_APPLICABLE) {
                      if (!this.IsUpdate) {
                        this.oTrpconsignment.CN_ST = this.oTrpcharges.GREEN_TAX;
                      }
                    }
                    while (this.lGreenTaxlist.length !== 0) {
                      this.lGreenTaxlist.pop();
                    }
                  }
                }
              }
              if (this.InvoiceList.length > 0 && this.IsDefaultChargeCalculate) {
                this.TextboxChargeCalculate(null);
              }
            });
        });
    }
  }

  public FillPaidToPayChargeDetail() {
    if (this.oTrpconsignment.CN_BILLPARTY != '' && this.oTrpconsignment.CN_BILLPARTY != undefined && this.oTrpconsignment.CN_FRT_MODE != "7") {
      this.oMasterConfigrationService.GetGreenTaxByLOC(this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC).subscribe(
        data1 => {
          this.lGreenTaxlist = data1;

          this.oMasterConfigrationService.GetPaidTopayChargeForGRBooking(this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC).subscribe(
            data => {
              this.oTrpPaidTopaycharge = data;
              if (!isNullOrUndefined(this.oTrpconsignment.CN_BILLPARTY)) {
                this.oMasterConfigrationService.GetChargesForGRBooking(this.oTrpconsignment.CN_BILLPARTY, this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC, parseInt(this.oTrpconsignment.CN_MODE)).subscribe(
                  dataCHG => {
                    this.oTrpcharges = dataCHG;
                    if (!this.IsUpdate || this.IsFreightTypeChange) {
                      this.oTrpconsignment.CN_UNITFRT = 0;
                      this.oTrpconsignment.CN_STCHG = 0;
                      this.oTrpconsignment.CN_COLCHG = 0;
                      this.oTrpconsignment.CN_DTDCHG = 0;
                      this.oTrpconsignment.CN_FOV = 0;
                      this.oTrpconsignment.CN_SPLVEHCHG = 0;
                      this.oTrpconsignment.CN_FREIGHT = 0;
                      this.oTrpconsignment.CN_ST = 0;
                    }
                    if (dataCHG[ 'Message' ] != "Record not found") {
                      if (this.oTrpcharges != null) {
                        if (parseFloat(isNullOrUndefined(this.oTrpcharges.FRT_PKG) ? "0" : this.oTrpcharges.FRT_PKG.toString()) > this.oTrpconsignment.CN_UNITFRT) {
                          this.IsPackage = true;
                          this.IsWeight = false;
                          this.FrightOnelected = "Packages";
                          this.IsFullLoad = false;
                          this.oTrpconsignment.CN_UNITFRT = this.oTrpcharges.FRT_PKG;
                        }
                        else if (parseFloat(isNullOrUndefined(this.oTrpcharges.FRT_WT) ? "0" : this.oTrpcharges.FRT_WT.toString()) > this.oTrpconsignment.CN_UNITFRT) {
                          this.IsWeight = true;
                          this.IsPackage = false;
                          this.FrightOnelected = "Weight";
                          this.IsFullLoad = false;
                          this.oTrpconsignment.CN_UNITFRT = this.oTrpcharges.FRT_WT;
                        }
                        if (!this.IsUpdate || this.IsFreightTypeChange) {
                          if (!isNullOrUndefined(this.oTrpcharges.ST_CRG) && !isNaN(this.oTrpcharges.ST_CRG)) {
                            this.oTrpconsignment.CN_STCHG = this.oTrpcharges.ST_CRG;
                          }
                          if (!isNullOrUndefined(this.oTrpcharges.CLC_CRG) && !isNaN(this.oTrpcharges.CLC_CRG)) {
                            this.oTrpconsignment.CN_COLCHG = this.oTrpcharges.CLC_CRG;
                          } else {
                            this.oTrpconsignment.CN_COLCHG = 0;
                          }
                          if (!isNullOrUndefined(this.oTrpcharges.DD_CRG) && !isNaN(this.oTrpcharges.DD_CRG)) {
                            this.oTrpconsignment.CN_DTDCHG = this.oTrpcharges.DD_CRG;
                          } else {
                            this.oTrpconsignment.CN_DTDCHG = 0;
                          }
                          if (!isNullOrUndefined(this.oTrpcharges.CN_SPLVEHCHG) && !isNaN(this.oTrpcharges.CN_SPLVEHCHG)) {
                            this.oTrpconsignment.CN_SPLVEHCHG = this.oTrpcharges.CN_SPLVEHCHG;
                          }
                          if (!this.IsUpdate) {
                            this.oTrpconsignment.CN_ST = 0;
                          }
                          if (!isNullOrUndefined(this.oTrpcharges.GREEN_TAX) && !isNaN(this.oTrpcharges.GREEN_TAX) && this.oTrpcharges.GREEN_TAX > 0) {
                            if (this.ModelPartyMaster.IS_GREENTAX_APPLICABLE) {
                              if (!this.IsUpdate) {
                                this.oTrpconsignment.CN_ST = this.oTrpcharges.GREEN_TAX;
                              }
                            }
                            // while (this.lGreenTaxlist.length !== 0) {
                            //   this.lGreenTaxlist.pop();
                            // }
                          }
                          this.lGreenTaxlist = [];
                        }
                        if (!isNullOrUndefined(this.oTrpcharges.SRV_CRG) && !isNaN(this.oTrpcharges.SRV_CRG)) {
                          this.labourBasecharge = this.oTrpcharges.SRV_CRG;
                        }
                      }
                    }
                    else {
                      this.oTrpconsignment.CN_UNITFRT = isNullOrUndefined(this.oTrpPaidTopaycharge.UNIT_FREIGHT) ? 0 : this.oTrpPaidTopaycharge.UNIT_FREIGHT;
                      if (!this.IsUpdate || this.IsFreightTypeChange) {
                        this.oTrpconsignment.CN_SPLVEHCHG = isNullOrUndefined(this.oTrpPaidTopaycharge.BARRIER_CHG) ? 0 : this.oTrpPaidTopaycharge.BARRIER_CHG;
                        this.oTrpconsignment.CN_STCHG = isNullOrUndefined(this.oTrpPaidTopaycharge.GR_CHG) ? 0 : this.oTrpPaidTopaycharge.GR_CHG;
                        this.labourBasecharge = isNullOrUndefined(this.oTrpPaidTopaycharge.LABOUR_CHG) ? 0 : this.oTrpPaidTopaycharge.LABOUR_CHG;
                      }
                    }
                    if (this.InvoiceList.length > 0 && this.IsDefaultChargeCalculate) {
                      this.TextboxChargeCalculate(null);
                    }
                  });
              }
            });
        });
    }
  }

  public FillFullLoadChargeDetail() {
    this.oTrpconsignment.CN_UNITFRT = 0;
    if (this.oTrpconsignment.CN_BILLPARTY != undefined && this.oTrpconsignment.CN_FRT_MODE != "7") {
      let FullLoadGreenTax: number;
      this.oMasterConfigrationService.GetGreenTaxFullLoadChargeForGRBooking(this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC, this.FullLoadVehicle).subscribe(
        data2 => {
          this.FrightOnelected = "FullLoad";
          if (!this.IsUpdate || this.IsFreightTypeChange) {
            this.oTrpconsignment.CN_UNITFRT = 0;
            this.oTrpconsignment.CN_STCHG = 0;
            this.oTrpconsignment.CN_COLCHG = 0;
            this.oTrpconsignment.CN_DTDCHG = 0;
            this.oTrpconsignment.CN_FOV = 0;
            this.oTrpconsignment.CN_SPLVEHCHG = 0;
            this.oTrpconsignment.CN_FREIGHT = 0;
            if (!isNullOrUndefined(data2.GREEN_TAX) && !isNaN(data2.GREEN_TAX) && data2.GREEN_TAX > 0) {
              if (this.ModelPartyMaster.IS_GREENTAX_APPLICABLE) {
                this.oTrpconsignment.CN_ST = data2.GREEN_TAX;
              } else { this.oTrpconsignment.CN_ST = 0; }
            } else { this.oTrpconsignment.CN_ST = 0; }
          }
          this.oMasterConfigrationService.GetFullLoadChargeForGR(this.oTrpconsignment.CN_BILLPARTY, this.FullLoadVehicle, this.oTrpconsignment.CN_LOC, this.oTrpconsignment.CN_TOLOC).subscribe(
            data => {

              // console.log(data['Message']);
              if (data[ 'Message' ] != "Record not found") {
                this.trpvtcharges = data;
                if (this.trpvtcharges != null) {
                  if (!this.IsUpdate || this.IsFreightTypeChange) {
                    this.oTrpconsignment.CN_FREIGHT = this.trpvtcharges.FRT;
                    this.oTrpconsignment.CN_STCHG = this.trpvtcharges.ST_CRG;
                    this.oTrpconsignment.CN_COLCHG = this.trpvtcharges.CLC_CRG;
                    this.oTrpconsignment.CN_DTDCHG = this.trpvtcharges.DD_CRG;
                    this.oTrpconsignment.CN_SPLVEHCHG = this.trpvtcharges.CN_SPLVEHCHG;

                    if (!isNullOrUndefined(this.trpvtcharges.SRV_CRG) && !isNaN(this.trpvtcharges.SRV_CRG)) {
                      this.labourBasecharge = this.trpvtcharges.SRV_CRG;
                      //console.log(this.labourBasecharge);
                    }
                  }
                }
              }
              if (this.InvoiceList.length > 0 && this.IsDefaultChargeCalculate) {
                this.TextboxChargeCalculate(null);
              }
            });
        });
    }
  }



  public GetBiller() {
    if (this.oTrpconsignment.CN_FRT_MODE == "5" && this.oTrpconsignment.CN_CRCODE != "" && this.oTrpconsignment.CN_CNCODE != "") {
      this.oMasterConfigrationService.GetPartyForDDL(6, parseInt(this.oTrpconsignment.CN_CRCODE), this.oTrpconsignment.CN_CNCODE).subscribe(
        data => {
          this.BillerList = data;
          this.BillerOptions = [];
          this.BillerList.forEach(element => {
            this.BillerOptions.push(element.ACC_CODE + ":" + element.ACC_NAME);
          });
          if (this.IsSubmit) {
            this.myControlBiller.setValue('a');
            this.myControlBiller.setValue('');
          }
        });
    }
    else {
      this.oMasterConfigrationService.GetPartyForDDL(3, 0, "").subscribe(
        data => {
          this.BillerList = data;
          this.BillerOptions = [];
          this.BillerList.forEach(element => {
            this.BillerOptions.push(element.ACC_CODE + ":" + element.ACC_NAME);
          });
          if (this.IsSubmit) {
            this.myControlBiller.setValue('a');
            this.myControlBiller.setValue('');
          }
        });
    }
  }

  public ConsigneeSelected(input: any) {
    this.IsDefaultChargeCalculate = true;
    this.IsFreightTypeChange = true;
    let item = this.PartySuppliers.filter(x => x.ACC_CODE == input.split(":")[ 0 ].trim());
    if (item.length > 0) {
      // this.ConsigneeNameAddress = item[0].ACC_CODE + ":" + item[0].ACC_NAME + " " + (item[0].ACC_ADD1 == null ? "" : item[0].ACC_ADD1) + " " + (item[0].ACC_ADD2 == null ? "" : item[0].ACC_ADD2);
      this.oTrpconsignment.CN_CNCODE = item[ 0 ].ACC_CODE.toString();
      this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_CNCODE).subscribe(
        data3 => {
          this.ModelPartyMaster = data3;
          this.oTrpconsignment.CN_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
          this.oTrpconsignment.CN_GSTNO = this.ModelPartyMaster.ACC_CSTNO;
        });
    }

    this.oMasterConfigrationService.GetSingleSupplierDetail(parseInt(this.oTrpconsignment.CN_CRCODE), parseInt(this.oTrpconsignment.CN_CNCODE)).subscribe(
      data4 => {
        this.oPartysupplier = data4;
        if (this.oPartysupplier != null) {
          this.oTrpconsignment.CN_FRT_MODE = this.oPartysupplier.CN_FRT_MODE;
          this.oTrpconsignment.CN_DELI_INST = this.oPartysupplier.CN_DELI_INST;
          if (this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "4") {
            //this.billingParty = input;
            this.myControlBiller.setValue(input);
            // this.BillingPartyNameAddress = this.ConsigneeNameAddress;
            this.oTrpconsignment.CN_BILLPARTY = input.split(":")[ 0 ].trim();
            this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
            if (!this.IsFullLoad) {
              if (this.oTrpconsignment.CN_FRT_MODE == "2") {
                this.FillPaidToPayChargeDetail();
              } else {
                this.FillChargeDetail();
              }
            }
            else {
              this.FillFullLoadChargeDetail();
            }
            // }
          }
          else if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "3" || this.oTrpconsignment.CN_FRT_MODE == "6") {
            let item = this.partylist.filter(x => x.ACC_CODE == this.oTrpconsignment.CN_CRCODE)
            this.myControlBiller.setValue(item[ 0 ].ACC_CODE.toString() + ":" + item[ 0 ].ACC_NAME.toString());
            this.oTrpconsignment.CN_BILLPARTY = this.oTrpconsignment.CN_CRCODE;
            this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
              data3 => {
                this.ModelPartyMaster = data3;
                this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
              });
            if (!this.IsFullLoad) {

              if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "6") {
                this.FillPaidToPayChargeDetail();
              } else {
                this.FillChargeDetail();
              }
            } else {
              this.FillFullLoadChargeDetail();
            }
          }
        }
      });
  }

  public BillingPartyelected(input: any) {
    this.IsDefaultChargeCalculate = true;
    let item = this.BillerList.filter(x => x.ACC_CODE == input.split(":")[ 0 ].trim())
    this.BillingPartyNameAddress = item[ 0 ].ACC_CODE + ":" + item[ 0 ].ACC_NAME + " " + (item[ 0 ].ACC_ADD1 == null ? "" : item[ 0 ].ACC_ADD1) + " " + (item[ 0 ].ACC_ADD2 == null ? "" : item[ 0 ].ACC_ADD2);
    this.oTrpconsignment.CN_BILLPARTY = input.split(":")[ 0 ].trim();
    this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
      data3 => {
        this.ModelPartyMaster = data3;
        this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
      });
    if (!this.IsFullLoad) {
      if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
        this.FillPaidToPayChargeDetail();
      } else {
        this.FillChargeDetail();
      }
    }
    else {
      this.FillFullLoadChargeDetail();
    }

  }


  public EditInvoice(item: any) {
    if (this.IsUpdate && this.oTrpconsignment.CN_BILLSTATUS != 'P') {
      alert("Edit not allowed after Bill generated");
      return;
    }
    else if (this.IsUpdate) {
      this.FillEditInvoiceDetail(item);
    }
    else if (this.IsSubmit) {
      this.FillEditInvoiceDetail(item);
    }
  }

  public FillEditInvoiceDetail(item: any) {

    this.ISEditInvoice = true;
    this.SelectedInvoiceId = item.InvoiceId;
    this.oTrpconsignmentinv.CN_INVOICE_ID = item.CNINVOICEID;
    this.oTrpconsignmentinv.CN_LOC = item.CNLOC;
    this.oTrpconsignmentinv.CN_NO = item.CNNO;
    this.oTrpconsignmentinv.CN_INVNO = item.CNINVNO;
    this.oTrpconsignmentinv.CN_INVDATE = item.CNINVDATE.split('T')[ 0 ];
    this.oTrpconsignmentinv.CN_INVVALUE = item.CNINVVALUE;
    this.oTrpconsignmentinv.CN_NETVALUE = item.CNNETVALUE;
    this.oTrpconsignmentinv.CN_ITMDESC = item.CNITMDESC;
    this.oTrpconsignmentinv.CN_BOXTYPE = item.CNBOXTYPE;
    this.oTrpconsignmentinv.CN_NOB = item.CNNOB;
    this.oTrpconsignmentinv.CN_PARTNO = item.CNPARTNO;
    this.oTrpconsignmentinv.CN_QTY = item.CNQTY;
    this.oTrpconsignmentinv.CN_H = item.CNH;
    this.oTrpconsignmentinv.CN_L = item.CNL;
    this.oTrpconsignmentinv.CN_W = item.CNW;
    this.oTrpconsignmentinv.CN_CFT = item.CNCFT;
    this.oTrpconsignmentinv.CN_ACTWT = item.CNACTWT;
    this.oTrpconsignmentinv.CN_CHGWT = item.CNCHGWT;
    this.oTrpconsignmentinv.TS = item.TS;
    this.oTrpconsignmentinv.CN_EWAYBILLNO = item.CNEWAYBILLNO;
    if (isNullOrUndefined(item.CNEWAYEXPIRYDT)) {
      this.oTrpconsignmentinv.CN_EWAYEXPIRYDT = item.CNEWAYEXPIRYDT;
    }
    else {
      this.oTrpconsignmentinv.CN_EWAYEXPIRYDT = item.CNEWAYEXPIRYDT.split('T')[ 0 ];
    }
    this.oTrpconsignmentinv.CN_PARTNO2 = item.CNPARTNO2;
    this.oTrpconsignmentinv.CN_PARTNO3 = item.CNPARTNO3;
    this.oTrpconsignmentinv.CN_PARTQTY1 = item.CNPARTQTY1;
    this.oTrpconsignmentinv.CN_PARTQTY2 = item.CNPARTQTY2;
    this.oTrpconsignmentinv.CN_PARTQTY3 = item.CNPARTQTY3;
    this.oTrpconsignmentinv.CREATEDBY_USERID = item.CREATEDBYUSERID;
    this.oTrpconsignmentinv.UPDATEDBY_USERID = item.UPDATEDBYUSERID;
    this.oTrpconsignmentinv.CREATED_DATE = item.CREATEDDATE;
    this.oTrpconsignmentinv.UPDATED_DATE = item.UPDATEDDATE;
    this.oTrpconsignmentinv.IS_ACTIVE = item.ISACTIVE;
  }

  public DeleteInvoice(item: any) {
    if (this.IsUpdate && this.oTrpconsignment.CN_STATUS != 'P' && (this.RoleId != 1 && this.RoleId != 7)) {
      alert("Delete not allowed after challan generated");
      return;
    }
    else if (this.IsUpdate && (this.RoleId == 1 || this.RoleId == 6 || this.RoleId == 7)) {
      // this.InvoiceList = this.InvoiceList.filter(x => x.CNINVNO != item.CNINVNO && x.CNINVVALUE != item.CNINVVALUE && x.CNNOB != item.CNNOB);
      this.InvoiceList = this.InvoiceList.filter(x => x.InvoiceId != item.InvoiceId);
      this.oTrpconsignment.CN_CHGWT = 0;
      if (this.InvoiceList.length > 0) {
        this.InvoiceId = this.InvoiceList.reduce((a, b) => Math.max(a, b));
        this.InvoiceId += 1;
      }
      else {
        this.InvoiceId = 1;
      }
      this.setPage(1);
      this.TextboxChargeCalculate(null);
      //------calculate slab charge-----------------------------
      this.PopulateGRUI();
      if (this.oTrpconsignment.CN_PWF == 'W' && this.oTrpcharges.MIN_WEIGHT != 0 && this.oTrpconsignment.CN_CHGWT < this.oTrpcharges.MIN_WEIGHT) {
        this.oTrpconsignment.CN_CHGWT = this.oTrpcharges.MIN_WEIGHT;
        this.TextboxChargeCalculate(null);
      }
      if (this.oTrpcharges.WEIGHT_SLAB > 1 && this.oTrpconsignment.CN_PWF == 'W') {
        let mode: number = 0;
        let conweight: number = this.oTrpconsignment.CN_CHGWT < this.oTrpcharges.WEIGHT_SLAB ? this.oTrpcharges.WEIGHT_SLAB : this.oTrpconsignment.CN_CHGWT;
        mode = conweight % this.oTrpcharges.WEIGHT_SLAB;
        if (mode > 0) {
          this.oTrpconsignment.CN_CHGWT = conweight + (this.oTrpcharges.WEIGHT_SLAB - mode);
          this.TextboxChargeCalculate(null);
        }
      }
      if (this.oTrpcharges.MIN_FREIGHT != 0 && this.oTrpconsignment.CN_FREIGHT < this.oTrpcharges.MIN_FREIGHT) {
        this.oTrpconsignment.CN_FREIGHT = this.oTrpcharges.MIN_FREIGHT;
        this.TextboxChargeCalculate(null);
      }
      //----------------------------End---------------------------
    }
    else if (this.IsSubmit) {
      // this.InvoiceList = this.InvoiceList.filter(x => x.CNINVNO != item.CNINVNO && x.CNINVVALUE != item.CNINVVALUE && x.CNNOB != item.CNNOB);
      this.InvoiceList = this.InvoiceList.filter(x => x.InvoiceId != item.InvoiceId);
      this.setPage(1);
      this.oTrpconsignment.CN_CHGWT = 0;
      this.InvoiceList.forEach(element => {
        if (this.InvoiceId < element.InvoiceId) {
          this.InvoiceId = element.InvoiceId;
        }
      });
      if (this.InvoiceList.length > 0) {
        this.InvoiceId = this.InvoiceList.reduce((a, b) => Math.max(a, b));
        this.InvoiceId += 1;
      }
      else {
        this.InvoiceId = 1;
      }
      this.TextboxChargeCalculate(null);
      //------calculate slab charge-----------------------------
      this.PopulateGRUI();
      if (this.oTrpconsignment.CN_PWF == 'W' && this.oTrpcharges.MIN_WEIGHT != 0 && this.oTrpconsignment.CN_CHGWT < this.oTrpcharges.MIN_WEIGHT) {
        this.oTrpconsignment.CN_CHGWT = this.oTrpcharges.MIN_WEIGHT;
        this.TextboxChargeCalculate(null);
      }
      if (this.oTrpcharges.WEIGHT_SLAB > 1 && this.oTrpconsignment.CN_PWF == 'W') {
        let mode: number = 0;
        let conweight: number = this.oTrpconsignment.CN_CHGWT < this.oTrpcharges.WEIGHT_SLAB ? this.oTrpcharges.WEIGHT_SLAB : this.oTrpconsignment.CN_CHGWT;
        mode = conweight % this.oTrpcharges.WEIGHT_SLAB;
        if (mode > 0) {
          this.oTrpconsignment.CN_CHGWT = conweight + (this.oTrpcharges.WEIGHT_SLAB - mode);
          this.TextboxChargeCalculate(null);
        }
      }
      if (this.oTrpcharges.MIN_FREIGHT != 0 && this.oTrpconsignment.CN_FREIGHT < this.oTrpcharges.MIN_FREIGHT) {
        this.oTrpconsignment.CN_FREIGHT = this.oTrpcharges.MIN_FREIGHT;
        this.TextboxChargeCalculate(null);
      }
      //----------------------------End---------------------------
    }
  }

  public CalculateCharge() {
    this.TotalInvoiceValue = parseFloat((parseFloat((this.oTrpconsignment.CN_FREIGHT == undefined ? 0 : this.oTrpconsignment.CN_FREIGHT).toString())
      + parseFloat((this.oTrpconsignment.CN_STCHG == undefined ? 0 : this.oTrpconsignment.CN_STCHG).toString())
      + parseFloat((this.oTrpconsignment.CN_COLCHG == undefined ? 0 : this.oTrpconsignment.CN_COLCHG).toString())
      + parseFloat((this.oTrpconsignment.CN_DTDCHG == undefined ? 0 : this.oTrpconsignment.CN_DTDCHG).toString())
      + parseFloat((this.oTrpconsignment.CN_FOV == undefined ? 0 : this.oTrpconsignment.CN_FOV).toString())
      + parseFloat((this.oTrpconsignment.CN_SPLVEHCHG == undefined ? 0 : this.oTrpconsignment.CN_SPLVEHCHG).toString())
      + parseFloat((this.oTrpconsignment.CN_OTHCHG == undefined ? 0 : this.oTrpconsignment.CN_OTHCHG).toString())
      + parseFloat((this.oTrpconsignment.CN_UNLOAD_CHARGE == undefined ? 0 : this.oTrpconsignment.CN_UNLOAD_CHARGE).toString())
      + parseFloat((this.oTrpconsignment.TOLL_CHARGE == undefined ? 0 : this.oTrpconsignment.TOLL_CHARGE).toString())
      + parseFloat((this.oTrpconsignment.DETENTION_CHARGE == undefined ? 0 : this.oTrpconsignment.DETENTION_CHARGE).toString())).toFixed(2));
  }

  public UnitFreightChange(event: any) {
    if (event == 'manualentry') {
      this.CalculateCharge();
      this.oTrpconsignment.NetTotal = this.TotalInvoiceValue;
      this.oTrpconsignment.GrandTotal = (parseFloat(this.TotalInvoiceValue.toString()) + parseFloat(this.oTrpconsignment.CN_ST == undefined ? "0" : this.oTrpconsignment.CN_ST.toString()));
      if (this.oTrpconsignment.CN_FRT_MODE == "1") {
        this.Mrgeneratedauto = true;
        if (this.Mrgeneratedauto) {
          //this.oTrpconsignment.TDS_AMT = (this.oTrpconsignment.GrandTotal * 2) / 100;
          this.oTrpconsignment.CN_MRAMT = this.oTrpconsignment.GrandTotal;
          //- this.oTrpconsignment.TDS_AMT;
        }
      }
    } else {
      if (this.InvoiceList.length == 0) {
        this.alerts.setMessage('Please add invoice before enter freight!', 'error');
        this.oTrpconsignment.CN_FREIGHT = 0;
        this.oTrpconsignment.CN_FOV = 0;
        this.oTrpconsignment.NetTotal = 0;
        // this.oTrpconsignment.CN_ST = 0;
        this.oTrpconsignment.GrandTotal = 0;
      }
      else {
        let totalQty: number = 0;
        if (this.FrightOnelected == "Quantity") {
          if (this.InvoiceList != undefined) {
            this.InvoiceList.forEach((e: any) => {
              totalQty = totalQty + Number(e.CNQTY);
            });
          }
        }
        else if (this.FrightOnelected == "Packages") {
          if (this.InvoiceList != undefined) {
            this.InvoiceList.forEach((e: any) => {
              totalQty = totalQty + Number(e.CNNOB);
            });
            if (this.labourBasecharge > 0) {
              this.oTrpconsignment.CN_FOV = parseFloat((this.labourBasecharge * totalQty).toFixed());
            }
          }
        }
        else if (this.FrightOnelected == "Weight") {
          if (this.InvoiceList != undefined) {
            this.InvoiceList.forEach((e: any) => {
              totalQty = totalQty + Number(e.CNCHGWT);
            });
            if (this.oTrpconsignment.CN_CHGWT > totalQty) {
              totalQty = this.oTrpconsignment.CN_CHGWT;
            }
            if (this.labourBasecharge > 0) {
              this.oTrpconsignment.CN_FOV = parseFloat((this.labourBasecharge * totalQty).toFixed());
            }
          }
        }
        else if (this.FrightOnelected == "FullLoad") {
          if (this.InvoiceList != undefined) {
            this.InvoiceList.forEach((e: any) => {
              totalQty = totalQty + Number(e.CNNOB);
            });
            if (this.labourBasecharge > 0) {
              this.oTrpconsignment.CN_FOV = parseFloat((this.labourBasecharge * totalQty).toFixed());
            }
          }
        }
        if (this.oTrpconsignment.CN_UNITFRT != undefined && this.oTrpconsignment.CN_UNITFRT != 0) {
          let cnfreiht: number;
          cnfreiht = parseFloat((this.oTrpconsignment.CN_UNITFRT * totalQty).toFixed(2));
          if (cnfreiht > this.oTrpconsignment.CN_FREIGHT && this.MinWeightAndFreightRuleApplied == true) {
            this.oTrpconsignment.CN_FREIGHT = cnfreiht;
          }
          else {
            this.oTrpconsignment.CN_FREIGHT = cnfreiht;
          }
        }

        this.CalculateCharge();

        this.oTrpconsignment.NetTotal = this.TotalInvoiceValue;
        let GreenTax: number = 0;
        if (this.lGreenTaxlist != null && this.lGreenTaxlist.length > 0) {
          if (this.ModelPartyMaster.IS_GREENTAX_APPLICABLE) {
            this.lGreenTaxlist.forEach(element => {
              if (totalQty >= element.FROM_SLAB && totalQty <= element.TO_SLAB && element.CALCULATE_ON == this.FrightOnelected) {
                GreenTax = parseFloat(element.GREENTAX_AMOUNT.toString());
              }
            });
          }
          else {
            GreenTax = this.oTrpconsignment.CN_ST;
          }
        }
        if (GreenTax > 0) {
          this.oTrpconsignment.CN_ST = GreenTax;
        }
        else {
          GreenTax = this.oTrpconsignment.CN_ST;
        }

        this.oTrpconsignment.GrandTotal = (parseFloat(this.TotalInvoiceValue.toString()) + parseFloat(GreenTax == undefined ? "0" : GreenTax.toString()));
        if (this.oTrpconsignment.CN_FRT_MODE == "1") {
          this.Mrgeneratedauto = true;
          if (this.Mrgeneratedauto) {
            this.oTrpconsignment.CN_MRAMT = this.oTrpconsignment.GrandTotal;
            //this.oTrpconsignment.TDS_AMT = (this.oTrpconsignment.GrandTotal * 2) / 100;
            this.oTrpconsignment.CN_MRAMT = this.oTrpconsignment.GrandTotal
            //- (isNaN(this.oTrpconsignment.TDS_AMT) ? 0 : this.oTrpconsignment.TDS_AMT);
          }
        }
      }
    }
  }



  public CalculateGreenTax(input: number) {
    if (input <= 500) {
      this.GreenTax = 100;
    }
    else if (input > 500 && input <= 1000) {
      this.GreenTax = 280;
    }
    else if (input > 1000 && input <= 1500) {
      this.GreenTax = 750;
    }
    else if (input > 1500 && input <= 2000) {
      this.GreenTax = 1000;
    }
    else if (input > 2000) {
      this.GreenTax = 1400;
    }
    this.oTrpconsignment.CN_ST = this.GreenTax;
  }


  public TextboxChargeCalculate(event: any) {
    if (isNullOrUndefined(this.oTrpconsignment.CN_UNITFRT) || this.oTrpconsignment.CN_UNITFRT.toString() == "") { this.oTrpconsignment.CN_UNITFRT = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_FREIGHT) || this.oTrpconsignment.CN_FREIGHT.toString() == "") { this.oTrpconsignment.CN_FREIGHT = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_STCHG) || this.oTrpconsignment.CN_STCHG.toString() == "") { this.oTrpconsignment.CN_STCHG = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_COLCHG) || this.oTrpconsignment.CN_COLCHG.toString() == "") { this.oTrpconsignment.CN_COLCHG = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_DTDCHG) || this.oTrpconsignment.CN_DTDCHG.toString() == "") { this.oTrpconsignment.CN_DTDCHG = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_FOV) || this.oTrpconsignment.CN_FOV.toString() == "") { this.oTrpconsignment.CN_FOV = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_SPLVEHCHG) || this.oTrpconsignment.CN_SPLVEHCHG.toString() == "") { this.oTrpconsignment.CN_SPLVEHCHG = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_OTHCHG) || this.oTrpconsignment.CN_OTHCHG.toString() == "") { this.oTrpconsignment.CN_OTHCHG = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_UNLOAD_CHARGE) || this.oTrpconsignment.CN_UNLOAD_CHARGE.toString() == "") { this.oTrpconsignment.CN_UNLOAD_CHARGE = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.TOLL_CHARGE) || this.oTrpconsignment.TOLL_CHARGE.toString() == "") { this.oTrpconsignment.TOLL_CHARGE = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.DETENTION_CHARGE) || this.oTrpconsignment.DETENTION_CHARGE.toString() == "") { this.oTrpconsignment.DETENTION_CHARGE = 0; }
    if (isNullOrUndefined(this.oTrpconsignment.CN_ST) || this.oTrpconsignment.CN_ST.toString() == "") { this.oTrpconsignment.CN_ST = 0; }
    this.UnitFreightChange(event);
  }


  public FRTModeselectedchanged(input: any) {
    this.IsDefaultChargeCalculate = true;
    this.IsFreightTypeChange = true;
    this.oTrpconsignment.CN_UNITFRT = 0;
    this.oTrpconsignment.CN_STCHG = 0;
    this.oTrpconsignment.CN_COLCHG = 0;
    this.oTrpconsignment.CN_DTDCHG = 0;
    this.oTrpconsignment.CN_FOV = 0;
    this.oTrpconsignment.CN_SPLVEHCHG = 0;
    this.oTrpconsignment.CN_FREIGHT = 0;

    if (input != "1") {
      this.Mrgeneratedauto = false;
      this.oTrpconsignment.TDS_AMT = 0;
      this.IsTDS = false;
      this.oTrpconsignment.CN_MRAMT = 0;
    }
    if (input == "6" || input == "2") { this.oTrpconsignment.CN_DELI_INST = "1"; }
    if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "3" || this.oTrpconsignment.CN_FRT_MODE == "6") {

      if (this.oTrpconsignment.CN_CRCODE != "" && this.oTrpconsignment.CN_CRCODE != undefined) {
        let item = this.partylist.filter(x => x.ACC_CODE == this.oTrpconsignment.CN_CRCODE)
        this.ConsignerNameAddress = item[ 0 ].ACC_CODE + ":" + item[ 0 ].ACC_NAME + " " + (item[ 0 ].ACC_ADD1 == null ? "" : item[ 0 ].ACC_ADD1) + " " + (item[ 0 ].ACC_ADD2 == null ? "" : item[ 0 ].ACC_ADD2) + " " + (item[ 0 ].ACC_ADD3 == null ? "" : item[ 0 ].ACC_ADD3);
        this.myControlBiller.setValue(item[ 0 ].ACC_CODE + ":" + item[ 0 ].ACC_NAME);
        this.BillingPartyNameAddress = this.ConsignerNameAddress;
        this.oTrpconsignment.CN_BILLPARTY = this.oTrpconsignment.CN_CRCODE;
        this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
          data3 => {
            this.ModelPartyMaster = data3;
            this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
          });
        if (!this.IsFullLoad) {
          if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "6") {
            this.FillPaidToPayChargeDetail();
          } else {
            this.FillChargeDetail();
          }
        } else {
          this.FillFullLoadChargeDetail();
        }
      }
    }
    else if (this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "4") {
      if (this.oTrpconsignment.CN_CNCODE != "" && this.oTrpconsignment.CN_CNCODE != undefined) {
        let item = this.PartySuppliers.filter(x => x.ACC_CODE == parseInt(this.oTrpconsignment.CN_CNCODE));
        if (item.length > 0) {
          this.ConsigneeNameAddress = item[ 0 ].ACC_CODE + ":" + item[ 0 ].ACC_NAME + " " + (item[ 0 ].ACC_ADD1 == null ? "" : item[ 0 ].ACC_ADD1) + " " + (item[ 0 ].ACC_ADD2 == null ? "" : item[ 0 ].ACC_ADD2);

          this.myControlBiller.setValue(item[ 0 ].ACC_CODE + ":" + item[ 0 ].ACC_NAME);
          this.BillingPartyNameAddress = this.ConsigneeNameAddress;
          this.oTrpconsignment.CN_BILLPARTY = this.oTrpconsignment.CN_CNCODE;
          this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
            data3 => {
              this.ModelPartyMaster = data3;
              this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
            });
          if (!this.IsFullLoad) {
            if (this.oTrpconsignment.CN_FRT_MODE == "2") {
              this.FillPaidToPayChargeDetail();
            } else {
              this.FillChargeDetail();
            }
          } else {
            this.FillFullLoadChargeDetail();
          }
        }
      }
    }
  }

  public calculateDimension() {
    let dblChgWT = 0;
    if (this.oTrpconsignmentinv.CN_L != undefined && this.oTrpconsignmentinv.CN_L > 0 && this.oTrpconsignmentinv.CN_W != undefined && this.oTrpconsignmentinv.CN_W > 0
      && this.oTrpconsignmentinv.CN_H != undefined && this.oTrpconsignmentinv.CN_H > 0 && this.oTrpconsignmentinv.CN_NOB != undefined && this.oTrpconsignmentinv.CN_NOB > 0 &&
      this.oTrpconsignmentinv.CN_CFT != undefined && this.oTrpconsignmentinv.CN_CFT > 0) {

      dblChgWT = (parseFloat(this.oTrpconsignmentinv.CN_L.toString()) * parseFloat(this.oTrpconsignmentinv.CN_W.toString()) * parseFloat(this.oTrpconsignmentinv.CN_H.toString())) / 1728 * parseFloat(this.oTrpconsignmentinv.CN_CFT.toString()) * parseFloat(this.oTrpconsignmentinv.CN_NOB.toString());
      this.oTrpconsignmentinv.CN_ACTWT = parseFloat(dblChgWT.toFixed(2));
      if (dblChgWT > parseFloat(this.oTrpconsignmentinv.CN_CHGWT.toString()))
        this.oTrpconsignmentinv.CN_CHGWT = parseFloat(dblChgWT.toFixed(2));;
    }
  }

  public AutoMRGeneration(event: any) {
    if (event.target.checked) {
      //this.oTrpconsignment.TDS_AMT = (this.oTrpconsignment.GrandTotal * 2) / 100;
      this.oTrpconsignment.CN_MRAMT = this.oTrpconsignment.GrandTotal
      //- (isNaN(this.oTrpconsignment.TDS_AMT) ? 0 : this.oTrpconsignment.TDS_AMT);
    }
    else {
      this.oTrpconsignment.CN_MRAMT = 0;
      //this.oTrpconsignment.TDS_AMT = 0;
    }
  }

  AutoTDSCalculation(event: any) {
    if (event.target.checked) {
      this.IsTDS = true;
      this.oTrpconsignment.TDS_AMT = (this.oTrpconsignment.CN_MRAMT * 2) / 100;
      this.oTrpconsignment.CN_MRAMT = (this.oTrpconsignment.CN_MRAMT - this.oTrpconsignment.TDS_AMT);
    }
    else {
      this.IsTDS = false;
      this.oTrpconsignment.CN_MRAMT = (this.oTrpconsignment.GrandTotal);
      this.oTrpconsignment.TDS_AMT = 0;
    }
  }

  public selectedchangedPaymentMode(input: any) {
    if (input == 1) {
      this.oTrpconsignment.CHEQUE_NO = "";
      this.LocationBankID = "0";
    }
  }

  public GetEwayDetail() {
    //console.log(this.InvoiceList.length);
    if (!isNullOrUndefined(this.oTrpconsignmentinv.CN_EWAYBILLNO) && this.InvoiceList.length == 0) {
      this.oApplicationcl.IsProgressBarEnable = true;
      let billerInput: string;
      this.oLookupService.GetEwayBillDetail(this.oTrpconsignmentinv.CN_EWAYBILLNO).subscribe(
        data => {
          this.oApplicationcl.IsProgressBarEnable = false;
          this.EwayDetail = data;
          //console.log(this.EwayDetail);
          if (this.EwayDetail != 'Error') {
            //console.log(this.EwayDetail.results.message);
            if (this.EwayDetail.results.message.eway_bill_number > 0) {

              //console.log(this.EwayDetail.results.message.eway_bill_number);

              if (this.EwayDetail.results.message.transporter_id.toUpperCase() == environment.gstin.toUpperCase()) {

                if (!isNullOrUndefined(this.EwayDetail.results.message.gstin_of_consignor) && this.EwayDetail.results.message.gstin_of_consignor != '') {

                  this.oMasterConfigrationService.GetPartyForByACC_CSTNO(this.EwayDetail.results.message.gstin_of_consignor).subscribe(
                    data2 => {
                      if (!isNullOrUndefined(data2)) {

                        billerInput = data2.ACC_CODE.toString() + ":" + data2.ACC_NAME
                        this.myControl.setValue(billerInput);

                        if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "3" || this.oTrpconsignment.CN_FRT_MODE == "6") {

                          this.myControlBiller.setValue(data2.ACC_CODE.toString() + ":" + data2.ACC_NAME);

                          this.oTrpconsignment.CN_BILLPARTY = data2.ACC_CODE.split(":")[ 0 ].trim();
                          this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
                            data3 => {
                              this.ModelPartyMaster = data3;
                              this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
                            });
                        }
                        else if (this.oTrpconsignment.CN_FRT_MODE == "5") { this.GetBiller(); }
                        if (!this.IsFullLoad) {
                          if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "6") {
                            this.FillPaidToPayChargeDetail();
                          } else {
                            this.FillChargeDetail();
                          }
                        } else {
                          this.FillFullLoadChargeDetail();
                        }
                      }
                    });

                  if (!isNullOrUndefined(this.EwayDetail.results.message.gstin_of_consignee) && this.EwayDetail.results.message.gstin_of_consignee != '') {

                    this.oMasterConfigrationService.GetPartyForByACC_CSTNO(this.EwayDetail.results.message.gstin_of_consignee).subscribe(
                      data3 => {
                        if (!isNullOrUndefined(data3)) {
                          this.oTrpconsignment.CN_CNCODE = data3.ACC_CODE.toString();
                          this.myControlConsignee.setValue(data3.ACC_CODE.toString() + ":" + data3.ACC_NAME);

                          this.oMasterConfigrationService.GetSingleSupplierDetail(parseInt(this.oTrpconsignment.CN_CRCODE), parseInt(this.oTrpconsignment.CN_CNCODE)).subscribe(
                            data4 => {
                              this.oPartysupplier = data4;
                              if (this.oPartysupplier != null) {
                                this.oTrpconsignment.CN_FRT_MODE = this.oPartysupplier.CN_FRT_MODE;
                                this.oTrpconsignment.CN_DELI_INST = this.oPartysupplier.CN_DELI_INST;
                                if (this.oTrpconsignment.CN_FRT_MODE == "2" || this.oTrpconsignment.CN_FRT_MODE == "4") {

                                  this.myControlBiller.setValue(data3.ACC_CODE.toString() + ":" + data3.ACC_NAME);
                                  // this.BillingPartyNameAddress = this.ConsigneeNameAddress;
                                  this.oTrpconsignment.CN_BILLPARTY = data3.ACC_CODE;
                                  this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
                                    data5 => {
                                      this.ModelPartyMaster = data5;
                                      this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
                                    });

                                  if (!this.IsFullLoad) {
                                    if (this.oTrpconsignment.CN_FRT_MODE == "2") {
                                      this.FillPaidToPayChargeDetail();
                                    } else {
                                      this.FillChargeDetail();
                                    }
                                  }
                                  else {
                                    this.FillFullLoadChargeDetail();
                                  }

                                }
                                else if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "3" || this.oTrpconsignment.CN_FRT_MODE == "6") {
                                  this.myControlBiller.setValue(billerInput);
                                  this.oTrpconsignment.CN_BILLPARTY = this.oTrpconsignment.CN_CRCODE;
                                  this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_BILLPARTY).subscribe(
                                    data5 => {
                                      this.ModelPartyMaster = data5;
                                      this.oTrpconsignment.BILL_MOBILENO = this.ModelPartyMaster.ACC_MOBILE1;
                                    });

                                  if (!this.IsFullLoad) {
                                    if (this.oTrpconsignment.CN_FRT_MODE == "1" || this.oTrpconsignment.CN_FRT_MODE == "6") {
                                      this.FillPaidToPayChargeDetail();
                                    } else {
                                      this.FillChargeDetail();
                                    }
                                  } else {
                                    this.FillFullLoadChargeDetail();
                                  }
                                }
                                else if (this.oTrpconsignment.CN_FRT_MODE == "5") { this.GetBiller(); }
                              }
                            });
                        }
                      });
                  }

                  this.oTrpconsignmentinv.CN_INVNO = this.EwayDetail.results.message.document_number;
                  this.oTrpconsignmentinv.CN_INVVALUE = this.EwayDetail.results.message.total_invoice_value;
                  //this.oTrpconsignmentinv.CN_PARTNO = this.EwayDetail.results.message.itemList[0].product_name;
                  this.oTrpconsignmentinv.CN_ITMDESC = this.EwayDetail.results.message.itemList[ 0 ].product_description;
                  this.oTrpconsignmentinv.CN_QTY = this.EwayDetail.results.message.itemList[ 0 ].quantity;

                  if (!isNullOrUndefined(this.EwayDetail.results.message.document_date)) {
                    this.oTrpconsignmentinv.CN_INVDATE = this.EwayDetail.results.message.document_date.substring(0, 10);

                  }
                  if (!isNullOrUndefined(this.EwayDetail.results.message.eway_bill_valid_date)) {
                    if (!isNullOrUndefined(this.EwayDetail.results.message.eway_bill_valid_date)) {
                      this.oTrpconsignmentinv.CN_EWAYEXPIRYDT = this.EwayDetail.results.message.eway_bill_valid_date.substring(0, 10);
                    }
                  }

                }
              }
            }
            else {
              alert("Invalid eway bill no");
            }
          }
        });
    }
  }

}

